export const HeroDiagram = ({ title, subtitle }) => {
  return (
    <div
      data-testid="hero-diagram"
      className="relative w-full aspect-square max-w-[560px] border border-[#0B1F3A]/15 bg-[#F8F9FA]"
    >
      <div className="absolute top-0 left-0 right-0 flex items-center justify-between px-4 py-3 border-b border-[#0B1F3A]/15 bg-white">
        <div className="flex items-center gap-2">
          <span className="w-1.5 h-1.5 bg-[#D4AF37]" />
          <span className="text-[10px] font-semibold tracking-[0.2em] uppercase text-[#0B1F3A]/70">
            {subtitle}
          </span>
        </div>
        <span className="text-[10px] tracking-widest text-[#0B1F3A]/50">v.2026</span>
      </div>

      <svg
        viewBox="0 0 500 500"
        className="absolute inset-0 w-full h-full"
        style={{ paddingTop: 44 }}
      >
        {/* grid */}
        <defs>
          <pattern id="grid" width="25" height="25" patternUnits="userSpaceOnUse">
            <path d="M 25 0 L 0 0 0 25" fill="none" stroke="rgba(11,31,58,0.06)" strokeWidth="1" />
          </pattern>
        </defs>
        <rect x="0" y="0" width="500" height="500" fill="url(#grid)" />

        {/* connecting lines */}
        <g stroke="#0B1F3A" strokeWidth="1" fill="none">
          {/* center to top */}
          <path d="M 250 250 L 250 110 L 250 110" />
          <path d="M 250 250 L 250 390" />
          <path d="M 250 250 L 110 250" />
          <path d="M 250 250 L 390 250" />
          {/* diagonals */}
          <path d="M 250 250 L 130 130" />
          <path d="M 250 250 L 370 130" />
          <path d="M 250 250 L 130 370" />
          <path d="M 250 250 L 370 370" />
        </g>

        {/* animated flow */}
        <g stroke="#2563EB" strokeWidth="1.5" fill="none" className="svg-flow">
          <path d="M 250 250 L 250 110" />
          <path d="M 250 250 L 390 250" />
          <path d="M 250 250 L 370 370" />
        </g>

        {/* outer nodes */}
        {[
          { x: 250, y: 90, label: "OPERATIONS" },
          { x: 410, y: 250, label: "DATA" },
          { x: 250, y: 410, label: "AI" },
          { x: 90, y: 250, label: "PEOPLE" },
          { x: 130, y: 130, label: "WORKFORCE" },
          { x: 370, y: 130, label: "EXPERIENCE" },
          { x: 130, y: 370, label: "LICENSING" },
          { x: 370, y: 370, label: "COMMERCIAL" },
        ].map((n, i) => (
          <g key={i}>
            <rect x={n.x - 44} y={n.y - 14} width="88" height="28" fill="#FFFFFF" stroke="#0B1F3A" strokeWidth="1" />
            <text
              x={n.x}
              y={n.y + 4}
              textAnchor="middle"
              fontSize="9"
              fontFamily="IBM Plex Sans, sans-serif"
              fontWeight="600"
              letterSpacing="1.4"
              fill="#0B1F3A"
            >
              {n.label}
            </text>
          </g>
        ))}

        {/* center node */}
        <g>
          <rect x="195" y="220" width="110" height="60" fill="#0B1F3A" />
          <rect x="195" y="220" width="110" height="60" fill="none" stroke="#D4AF37" strokeWidth="1.5" />
          <text x="250" y="246" textAnchor="middle" fontSize="11" fontFamily="IBM Plex Sans" fontWeight="600" letterSpacing="1.5" fill="#D4AF37">
            DIGITAL OS
          </text>
          <text x="250" y="262" textAnchor="middle" fontSize="8.5" fontFamily="Inter" fill="#FFFFFF" letterSpacing="1.2">
            {title}
          </text>
          <circle cx="250" cy="275" r="1.5" fill="#D4AF37" className="node-pulse" />
        </g>

        {/* corner ticks */}
        <g stroke="#0B1F3A" strokeWidth="1" fill="none">
          <path d="M 10 60 L 20 60 M 10 60 L 10 70" />
          <path d="M 490 60 L 480 60 M 490 60 L 490 70" />
          <path d="M 10 490 L 20 490 M 10 490 L 10 480" />
          <path d="M 490 490 L 480 490 M 490 490 L 490 480" />
        </g>
      </svg>

      <div className="absolute bottom-0 left-0 right-0 flex items-center justify-between px-4 py-2 border-t border-[#0B1F3A]/15 bg-white">
        <span className="text-[10px] tracking-widest uppercase text-[#0B1F3A]/50">PEOPLE · OPERATIONS · DATA · AI</span>
        <span className="text-[10px] tracking-widest text-[#D4AF37] font-semibold">ACTIVE</span>
      </div>
    </div>
  );
};
